import {
  applyPreferencesToDom,
  clampScaleIndex,
  defaultPreferences,
  loadPreferences,
  saveAndApplyPreferences,
} from "@/_utils/accessibility";

const state = () => ({
  preferences: { ...defaultPreferences },
});

const getters = {
  textScaleIndex: (currentState) => currentState.preferences.textScaleIndex,
  preferences: (currentState) => currentState.preferences,
};

const mutations = {
  setPreferences(currentState, preferences) {
    currentState.preferences = { ...currentState.preferences, ...preferences };
  },
};

const actions = {
  init({ commit }) {
    const storedPreferences = loadPreferences();
    commit("setPreferences", storedPreferences);
    applyPreferencesToDom(storedPreferences);
  },
  increaseTextScale({ state: currentState, commit }) {
    const nextIndex = clampScaleIndex(currentState.preferences.textScaleIndex + 1);
    const updated = { ...currentState.preferences, textScaleIndex: nextIndex };
    commit("setPreferences", updated);
    saveAndApplyPreferences(updated);
    return nextIndex;
  },
  decreaseTextScale({ state: currentState, commit }) {
    const nextIndex = clampScaleIndex(currentState.preferences.textScaleIndex - 1);
    const updated = { ...currentState.preferences, textScaleIndex: nextIndex };
    commit("setPreferences", updated);
    saveAndApplyPreferences(updated);
    return nextIndex;
  },
  togglePreference({ state: currentState, commit }, key) {
    const updated = {
      ...currentState.preferences,
      [key]: !currentState.preferences[key],
    };
    commit("setPreferences", updated);
    saveAndApplyPreferences(updated);
    return updated[key];
  },
  resetPreferences({ commit }) {
    commit("setPreferences", { ...defaultPreferences });
    saveAndApplyPreferences({ ...defaultPreferences });
  },
};

export const accessibility = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
